import { AssistantPlanPanel } from "@/components/assistant/AssistantPlanPanel";
import { useAssistantPlan } from "@/components/assistant/AssistantPlanContext";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type Props = {
  header: ReactNode;
  messageArea: ReactNode;
  composer: ReactNode;
  className?: string;
};

export function AssistantPanelPlanSplit({
  header,
  messageArea,
  composer,
  className,
}: Props) {
  const { open: planOpen, snapshot } = useAssistantPlan();
  const showPlanSplit = planOpen && snapshot;

  return (
    <div
      className={cn(
        "relative flex h-full min-h-0 w-full flex-col overflow-hidden rounded-2xl border border-[rgba(15,23,42,0.09)] bg-[var(--chat-shell-bg)] shadow-[var(--shadow-card)] dark:border-white/10 dark:shadow-none",
        className
      )}
    >
      {header}
      {showPlanSplit ? (
        <div className="flex min-h-0 flex-1 flex-col gap-0 max-lg:min-h-0 lg:flex-row lg:items-stretch">
          <div className="flex min-h-0 min-w-0 flex-1 flex-col max-lg:max-h-[min(420px,45dvh)] max-lg:shrink-0">
            <AssistantPlanPanel variant="embedded" />
          </div>
          <div
            className={cn(
              "flex min-h-0 min-w-0 flex-1 flex-col border-[rgba(15,23,42,0.09)] max-lg:border-t lg:min-h-0 lg:w-[var(--inline-assistant-chat-w,380px)] lg:shrink-0 lg:flex-none lg:border-l lg:border-t-0 dark:border-white/10"
            )}
          >
            {messageArea}
            {composer}
          </div>
        </div>
      ) : (
        <>
          {messageArea}
          {composer}
        </>
      )}
    </div>
  );
}
